import React from 'react';
import ReactDOM from 'react-dom';
import App from 'scenes/app';
import { init } from '@sentry/browser';
import 'styles/index.scss';

if (process.env.NODE_ENV !== 'development') {
  init({
    dsn: process.env.REACT_APP_SENTRY_CONSUMER_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.querySelector('#root'),
);
